import { DESCENDING } from 'constants/sortDirections';
import { PaginationVariant } from 'ui/pagination';
import { Table } from 'ui/table';
import noop from 'utils/noop';

import { LOADING_HEADER_COLUMNS, LOADING_ROWS } from '../constants';
import {
  StyledHeader,
  TableFooter,
  StyledPagination,
  StyledPageSize,
  TotalEvents,
  TableWrapper,
  StyledLoadingRows,
} from './styled';
import { ExtendedEventInfo } from '../types';

export const TableLoader = () => {
  return (
    <TableWrapper data-test="table-loading-state">
      <Table>
        <StyledHeader
          columns={LOADING_HEADER_COLUMNS}
          sortedBy={'name' as keyof ExtendedEventInfo}
          setSortedBy={noop}
          sortDirection={DESCENDING}
          setSortDirection={noop}
          isSticky
        />
        <StyledLoadingRows idKey="value" rows={LOADING_ROWS} columns={LOADING_HEADER_COLUMNS} />
      </Table>
      <TableFooter>
        <TotalEvents>
          <span>-- total</span>
        </TotalEvents>
        <StyledPagination pages={3} page={1} variant={PaginationVariant.Grey} onChangePage={noop} />
        <StyledPageSize total={10} pageSizes={[10, 20, 30, 40, 50]} onSelect={noop} />
      </TableFooter>
    </TableWrapper>
  );
};
